var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbsup(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m286.8 1012.8c168 9.6016 385.2 94.801 518.4 94.801 129.6 0 208.8-22.801 201.6-116.4 56.398-31.199 73.199-102 56.398-153.6 49.199-30 69.602-109.2 39.602-157.2 56.398-49.199 43.199-126-6-156-51.602-32.402-226.8-32.402-226.8-32.402s85.199-208.8 52.801-307.2c-16.801-49.199-43.199-78-74.398-90-21.602-8.3984-44.398 4.8008-48 27.602-8.3984 45.602-27.602 111.6-60 175.2-64.801 129.6-194.4 129.6-259.2 194.4-97.199 97.199-194.4 97.199-194.4 97.199z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m60 589.2h180v488.4h-180z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsup);
export default __webpack_public_path__ + "static/media/thumbsup.aa96892e3f8d88bd41a1d3806fd4b2be.svg";
export { ForwardRef as ReactComponent };